// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   selectedItems: ["Front Side","Front Left Side","Left Side","Back Left Side","Back Side","Back Right Side", "Right Side","Front Right Side","Chassis","Windshield","Odometer","Video of RMP","Registration number","RC","Selfie with the car"],
//   selectedMode: ["Photo"],
//   selectedCount: 16,
// };

// const inspectionConfigSlice = createSlice({
//   name: "inspectionConfig",
//   initialState,
//   reducers: {
//     toggleItem: (state, action) => {
//       const item = action.payload;
//       if (state.selectedItems.includes(item)) {
//         state.selectedItems = state.selectedItems.filter((i) => i !== item);
//       } else {
//         state.selectedItems.push(item);
//       }
//     },
//     setSelectedMode: (state, action) => {
//       state.selectedMode = action.payload;
//     },
//     setSelectedCount: (state, action) => {
//       state.selectedCount = action.payload;
//     },
//     resetInspectionConfig: () => initialState,
//   },
// });

// export const inspectionConfigActions =  inspectionConfigSlice.actions;
// export default inspectionConfigSlice;


import { createSlice } from "@reduxjs/toolkit";

// Configuration for each plan
const planConfigurations = {
  Basic: {
    selectedItems: [
      "Front Side", "Front Left Side", "Left Side", "Back Left Side", 
      "Back Side", "Back Right Side", "Right Side", "Front Right Side", 
      "Chassis", "Windshield", "Odometer", "Registration number", 
      "RC", "Selfie with the car","Video of RMP"
    ],
    selectedMode: ["Photo"],
    selectedCount: 15
  },
  Standard: {
    selectedItems: [
      "Front Side", "Front Left Side", "Left Side", "Back Left Side", 
      "Back Side", "Back Right Side", "Right Side", "Front Right Side", 
      "Chassis", "Windshield", "Odometer", "Video of RMP",
      "Registration number", "RC", "Selfie with the car"
    ],
    selectedMode: ["Photo", "Video", ],
    selectedCount: 15
  },
  Premium: {
    selectedItems: [
      "Front Side", "Front Left Side", "Left Side", "Back Left Side", 
      "Back Side", "Back Right Side", "Right Side", "Front Right Side", 
      "Chassis", "Windshield", "Odometer", "Video of RMP",
      "Registration number", "RC", "Selfie with the car", 
      "Tyres"
    ],
    selectedMode: ["Photo", "Video", "Hybrid"],
    selectedCount: 20
  }
};

const initialState = {
  selectedItems: planConfigurations.Basic.selectedItems,
  selectedMode: planConfigurations.Basic.selectedMode,
  selectedCount: planConfigurations.Basic.selectedCount,
  currentPlan: "Basic"
};

const inspectionConfigSlice = createSlice({
  name: "inspectionConfig",
  initialState,
  reducers: {
    toggleItem: (state, action) => {
      const item = action.payload;
      if (state.selectedItems.includes(item)) {
        state.selectedItems = state.selectedItems.filter((i) => i !== item);
      } else {
        state.selectedItems.push(item);
      }
    },
    setSelectedMode: (state, action) => {
      state.selectedMode = action.payload;
    },
    setSelectedCount: (state, action) => {
      state.selectedCount = action.payload;
    },
    setPlan: (state, action) => {
      const plan = action.payload;
      if (planConfigurations[plan]) {
        state.currentPlan = plan;
        state.selectedItems = planConfigurations[plan].selectedItems;
        state.selectedMode = planConfigurations[plan].selectedMode;
        state.selectedCount = planConfigurations[plan].selectedCount;
      }
    },
    resetInspectionConfig: () => initialState,
  },
});

export const inspectionConfigActions = inspectionConfigSlice.actions;
export default inspectionConfigSlice;
